import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { Filters } from "./Filters"
import { getAllJackpots } from "store/jackpots/actions"
import { useSelector, useDispatch } from "react-redux"
import { getAllEvents } from "store/events/actions"
import {sitename} from "../../../constants/constants";

const Jackpot = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllJackpots())
    dispatch(getAllEvents())
  }, [])

  const Jackpots = useSelector(state => state.jackpots.Index ?? [])
  const Events = useSelector(state => state.events.Index ?? [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Jackpots" />
        </Container>
        <Filters />
        <Table data={Jackpots} events={Events} />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Jackpot)
